import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;
const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const AssociationNetworkService = {
    getById: async (id) => axios.get(API_KEEPER + `/association-network/${id}`).then((data) => data).catch((err) => { throw err }),
    openVehicleProfile: async (plate) => axios.get(API_URL + `/association-network/openVehicleProfile/${plate}`).then((data) => data).catch((err) => { throw err }),
    openSearch: async (formData) => axios.post(API_URL + `/association-network/openSearch`, formData).then((data) => data).catch((err) => { throw err }),
    init: async (formData) => axios.post(API_KEEPER + `/analysis/associationNetwork/init`, formData).then((data) => data).catch((err) => { throw err }),
    save: async (data) => axios.post(API_KEEPER + `/association-network`, data).then(data => data).catch((err) => { throw err }),
    delete: async (id) => axios.delete(API_KEEPER + `/association-network/${id}`).then(({data}) => data).catch((err) => { throw err }),
    list: async () => axios.get(`${API_KEEPER}/association-network/list`).then(({data}) => data).catch((err) => { throw err }),
    auditView: async (id) => axios.get(`${API_KEEPER}/association-network/audit-view/${id}`).then(({data}) => data).catch((err) => { throw err }),
}

export default AssociationNetworkService;